import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconCursor = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M10.409 1.924a9.36 9.36 0 0 0-5.695 2.614c-1.62 1.57-2.587 3.634-2.792 5.958-.09 1.013-.09 41.995 0 43.008.205 2.324 1.173 4.389 2.792 5.959 1.584 1.535 3.532 2.416 5.782 2.615 1.027.09 41.823.09 42.78 0 4.403-.418 7.731-3.474 8.689-7.979l.147-.691.019-20.992c.013-14.32-.003-21.256-.049-21.824-.188-2.316-1.056-4.265-2.62-5.878-1.57-1.62-3.634-2.587-5.958-2.792-.88-.078-42.218-.076-43.095.002m.001 4.03c-2.078.352-3.668 1.756-4.31 3.81l-.18.572v43.328l.18.573c.575 1.837 1.826 3.088 3.663 3.664l.573.179H31.84c20.647 0 21.52-.005 21.92-.117 1.04-.293 1.831-.726 2.513-1.377a5.85 5.85 0 0 0 1.77-3.466c.06-.416.073-5.501.057-21.664l-.02-21.12-.18-.573c-.575-1.837-1.826-3.088-3.663-3.664l-.573-.179-21.472-.009c-11.81-.005-21.611.015-21.782.044m33.718 9.881c-.318.09-29.761 12.684-30.43 13.016-.192.095-.53.342-.752.549-1.201 1.12-1.28 2.912-.178 4.066.42.44.936.734 1.472.837.211.041 3.288.473 6.837.96s6.468.9 6.487.92.448 3.02.952 6.67l.917 6.633.226.476c.981 2.067 3.68 2.428 4.938.661.203-.286 13.145-30.394 13.325-31 .13-.437.076-1.302-.111-1.788-.313-.811-1.137-1.62-1.932-1.896-.519-.18-1.317-.227-1.751-.104M31.09 25.75c-6.572 2.821-11.93 5.146-11.904 5.168.025.02 2.422.364 5.326.762s5.388.761 5.52.808a2 2 0 0 1 1.23 1.243c.052.157.414 2.619.803 5.47s.73 5.237.756 5.302c.034.084 1.517-3.312 5.15-11.787 5.768-13.46 5.195-12.109 5.124-12.1-.03.003-5.432 2.314-12.005 5.134" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconCursor.displayName = 'IconCursor';